import { Dict } from "../models/base/Dict";

/**
 *
 * @param template the path tempalte containing template litrals either as :id or {{id}} or {id}
 * @param values
 * @returns
 */
export const buildPathString = (template: string, values: Dict): string => {
  //
  const buildColonPrefixedTemplateLitrals = Object.keys(values).reduce((str, key) => {
    const pattern = new RegExp(`:${key}\\b`, "g");
    return str.replace(pattern, values[key]);
  }, template);

  // first double, then single
  const buildDoubleHandlebarsTemplateLitrals = Object.keys(values).reduce((str, key) => {
    const pattern = new RegExp(`\{\{${key}\}\}`, "g");

    return str.replace(pattern, values[key]);
  }, buildColonPrefixedTemplateLitrals);

  const buildSingleHandlebarsTemplateLitrals = Object.keys(values).reduce((str, key) => {
    const pattern = new RegExp(`\{${key}\}`, "g");
    return str.replace(pattern, values[key]);
  }, buildDoubleHandlebarsTemplateLitrals);

  return buildSingleHandlebarsTemplateLitrals;
};
